import React, { createContext } from 'react';

export const ChatStreamContext = createContext(null);

export const withChatContext = Component => props => (
  <ChatStreamContext.Consumer>
    {chat => <Component {...props} chatContext={chat} />}
  </ChatStreamContext.Consumer>
);